<template>
  <b-modal
    size="xl"
    centered
    ref="ThongTinDonVi"
    no-close-on-backdrop
    hide-footer
    :title="
      `${isChoose ? 'Chọn' : data ? 'Sửa' : 'Thêm mới'} thông tin đăng nhập`
    "
  >
    <b-form class="font-size-14">
      <ValidationObserver ref="observer" tag="form">
        <b-row>
          <b-col cols="9" v-if="isChoose">
            <ValidationProvider rules="required">
              <div slot-scope="{ errors }">
                <b-form-group label="Tên đăng nhập" class="required">
                  <v-select
                    ref="gioiTinh"
                    :multiple="false"
                    v-model="form.tenDangNhap"
                    :options="listDangNhap || []"
                    required
                    @input="chooseUser(form.tenDangNhap)"
                    label="userName"
                    :reduce="(name) => name"
                    title="Chọn tên đăng nhập"
                    placeholder="Chọn tên đăng nhập"
                    :class="{ 'is-danger-select': errors.length > 0 }"
                  >
                  </v-select>
                  <p :class="{ error: errors.length > 0 }">
                    {{ errors.length > 0 ? "Vui lòng chọn tên đăng nhập" : "" }}
                  </p>
                </b-form-group>
              </div>
            </ValidationProvider>
          </b-col>
          <template v-else>
            <b-col cols="3">
              <ValidationProvider
                name="Tên đăng nhập"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-group label="Tên đăng nhập" class="required">
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    type="text"
                    v-model="form.tenDangNhap"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="3">
              <ValidationProvider
                name="Mật khẩu"
                rules="required"
                vid="password"
                v-slot="validationContext"
              >
                <b-form-group label="Mật khẩu" class="required">
                  <b-form-input
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    type="password"
                    v-model="form.matKhau"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="3">
              <ValidationProvider
                name="lại mật khẩu"
                rules="required|confirmed:password"
                v-slot="validationContext"
              >
                <b-form-group label="Nhập lại mật khẩu" class="required">
                  <b-form-input
                    type="password"
                    :state="getValidationState(validationContext)"
                    id="hoTen"
                    v-model="form.nhapLaiMatKhau"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </template>
          <b-col cols="3">
            <ValidationProvider
              name="Trạng thái"
              rules="required"
              v-slot="validationContext"
            >
              <b-form-group label="Trạng thái" class="required">
                <v-select
                  :options="danhSachTrangThai"
                  :reduce="(item) => item"
                  :clearable="false"
                  label="name"
                  v-model="form.trangThai"
                ></v-select>
              </b-form-group>
              <b-form-invalid-feedback
                >{{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </ValidationProvider>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Ứng dụng"
              label-for="app"
              class="required"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Ứng dụng"
                rules="requiredMultiple"
                v-slot="validationContext"
              >
                <MultiSelect
                  :options="list || []"
                  v-if="showSelect"
                  optionLabel="name"
                  class="w-100"
                  placeholder="Chọn ứng dụng"
                  :state="getValidationState(validationContext)"
                  :class="{
                    'select-invalid is-invalid':
                      validationContext.errors.length > 0,
                  }"
                  :disabled="readonly"
                  v-model="form.ungDung"
                ></MultiSelect>

                <b-form-invalid-feedback
                  :force-show="
                    validationContext.invalid && validationContext.validated
                  "
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
          </b-col>
        </b-row>
      </ValidationObserver>
    </b-form>
    <div style="text-align: center" class="float-right">
      <base-button
        button="Xác nhận"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="primary"
        @click="onSave()"
        >Tạo</base-button
      >
      <base-button
        button="Đóng"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="outline-secondary"
        @click="hideModal()"
        >Hủy
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import _cloneDeep from "lodash/cloneDeep";
export default {
  name: "ModalThemThongTinDonVi",
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
    },
    isChoose: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      listDangNhap: [],
      showSelect: true,
      form: {
        tenDangNhap: "",
        matKhau: "",
        nhapLaiMatKhau: "",
        ungDung: null,
        trangThai: {
          id: true,
          name: "Hoạt động",
        },
      },
      danhSachTrangThai: [
        {
          id: true,
          name: "Hoạt động",
        },
        {
          id: false,
          name: "Không hoạt động",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/danhSachAppPaging",
    }),
  },
  watch: {
    danhSachApp: function(val) {
      //   this.list = val
      console.log(val);
    },
    reload: function() {
      if (this.data) {
        this.form = _cloneDeep(this.data);
        this.showSelect = false;
        let list = [];
        this.form.ungDung.forEach((item) => {
          list.push(this.getItem(item.id));
        });
        this.form.ungDung = list;
        this.showSelect = true;
        if (!this.isChoose)
          this.form.tenDangNhap = this.form.tenDangNhap.userName;
      } else {
        this.form = {
          tenDangNhap: "",
          matKhau: "",
          nhapLaiMatKhau: "",
          ungDung: null,
          trangThai: {
            id: true,
            name: "Hoạt động",
          },
        };
      }
    },
  },
  created() {
    this.layDanhSachApp();
    this.layDanhSachAccount();
  },
  methods: {
    getItem(id) {
      const list = this.list || [];
      let findItem = list.find((item) => item.id == id);
      return findItem ? findItem : null;
    },
    chooseUser(user) {
      this.form.ungDung = [];
      user.applications.forEach((item) => {
        this.form.ungDung.push(this.getApp(item.applicationId));
      });
    },
    getApp(id) {
      const list = this.list || [];
      let findItem = list.find((item) => item.id == id);
      return findItem ? findItem : null;
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp", {
        pageIndex: 0,
        pageSize: 100,
        onSuccess: (data) => {
          this.list = data;
        },
      });
    },
    layDanhSachAccount() {
      this.$store.dispatch("canBo/layDanhSachTaiKhoan", {
        pageIndex: 0,
        pageSize: 100,
        onSuccess: (data) => {
          this.listDangNhap = data;
        },
      });
    },
    hideModal() {
      this.$refs.ThongTinDonVi.hide();
      this.form = {
        tenDangNhap: "",
        matKhau: "",
        nhapLaiMatKhau: "",
        ungDung: null,
        trangThai: {
          id: true,
          name: "Hoạt động",
        },
      };
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async onSave() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      let isExisted = false;
      if (!this.isChoose) {
        await this.$store
          .dispatch("canBo/checkUserExisted", {
            userName: this.form.tenDangNhap,
          })
          .then((res) => {
            if (!res.data) {
              this.$toasted.global.showErrorMessage({
                message: "Tài khoản đã tồn tại!",
              });
              isExisted = true;
            }
          });
        if (isExisted) {
          return;
        }
        const get = this.form.tenDangNhap;
        this.form.tenDangNhap = {
          userName: get,
          trangThai: { id: 1 },
        };
      }
      this.form.tenDangNhap = {
        ...this.form.tenDangNhap,
        trangThai: { id: 1 },
      };
      if (this.data) {
        this.$emit("onEdit", this.form);
      } else {
        this.$emit("onSave", this.form);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vs__dropdown-toggle {
  height: auto !important;
}
</style>
